module.exports = __webpack_public_path__ + "img/banner2.ff9dd2b8.jpg";